import {useEffect, useRef, useState} from 'react';
import {reportsApi} from '../api/reports.api';
import {ReportTemplate} from '../types/report-builder.types';
import {useReportError} from './use-report-error';

export const useReportList = (myOnly: boolean, canView: boolean, companyId?: string) => {
  const [reports, setReports] = useState<ReportTemplate[]>([]);
  const [ownIds, setOwnIds] = useState<Set<number>>(new Set());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const reportError = useReportError();
  const request = useRef(0);

  useEffect(() => {
    const current = ++request.current;
    if (!canView) {
      setLoading(false);
      setReports([]);
      return;
    }
    setLoading(true);
    setError('');
    const mine = reportsApi.list({myOnly: true});
    Promise.all([myOnly ? mine : reportsApi.list({myOnly: false}), mine])
      .then(([all, own]) => {
        if (request.current !== current) return;
        setReports([...all].sort((a, b) => a.name.localeCompare(b.name, 'ru') || a.id - b.id));
        setOwnIds(new Set(own.map((report) => report.id)));
      })
      .catch(async (error: unknown) => {
        const result = await reportError(error, 'Не удалось загрузить отчёты. Попробуйте ещё раз.');
        if (request.current === current) setError(result.message);
      })
      .finally(() => {
        if (request.current === current) setLoading(false);
      });
    return () => {
      request.current += 1;
    };
  }, [myOnly, canView, companyId, revision, reportError]);

  return {reports, ownIds, loading, error, refresh: () => setRevision((value) => value + 1)};
};
